var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal, ModalBody, ModalFoot, ModalHead } from '@dixa/lib-shared-habla';
import { loggedOutRedirect, okta } from 'lib-shared-auth';
import { useCallback } from 'react';
import { appActions } from 'app/app.actions';
import { analytics } from 'app/utils/segment';
import { Sentry, SentryTeam } from 'app/utils/sentry';
import { dixaWidgetPurgeUser } from 'components/widget/utils/widget';
import { authManager } from 'utils/auth/authManager';
import { createAppModal } from 'utils/modal';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';
/** A component that displays a modal for logging out the agent. */
export const LogOutModal = createAppModal({ type: 'app:logOut' }, ({ isOpen, hide }) => {
    const dispatch = useAppDispatch();
    const loginType = useAppSelector((state) => state.app.logInType);
    /** Handles the modal confirm action. */
    const handleConfirm = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const authData = yield authManager.getAuth();
        if (authData === null || authData === void 0 ? void 0 : authData.refresh_token) {
            yield dispatch(appActions.logOut({ refreshToken: authData.refresh_token }));
            Sentry.captureMessage('User logged out', {
                level: 'info',
                tags: {
                    team: SentryTeam.Platform,
                },
            });
            dixaWidgetPurgeUser();
            authManager.removeAuthData();
            (_a = window.analytics) === null || _a === void 0 ? void 0 : _a.reset();
            if (loginType === 'oktaClient') {
                okta.logOut();
            }
            else {
                loggedOutRedirect();
            }
            analytics.signOutConfirmed();
        }
    }), [dispatch, loginType]);
    /** Handles the modal cancel action. */
    const handleCancel = useCallback(() => {
        analytics.signOutAborted();
        hide === null || hide === void 0 ? void 0 : hide();
    }, [hide]);
    return (_jsxs(Modal, Object.assign({ isOpen: isOpen, onClose: handleCancel }, { children: [_jsx(ModalHead, { title: "Sign out", onClose: handleCancel }), _jsx(ModalBody, { children: "Are you sure you want to sign out?" }), _jsx(ModalFoot, { cancelName: "No, stay online", cancelOnClick: handleCancel, cancelProps: {
                    variant: 'secondary',
                }, confirmName: "Yes, sign me out", confirmOnClick: handleConfirm, confirmProps: {
                    variant: 'danger',
                    id: 'logOutButton',
                } })] })));
});
